import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <section className="landing-hero">
      <h1>CoinfallSMP Publish</h1>
      <p className="form-hint">
        This is where CoinfallSMP creators upload and manage videos for the official media
        site. Log in if you already have a creator account, or apply for one if you don't.
      </p>
      <div className="button-row">
        <Link to="/login" className="button secondary">
          Log in
        </Link>
        <Link to="/apply" className="button primary">
          Apply for Creator
        </Link>
      </div>
      <p className="form-hint">
        Just here to watch? Browse published videos at{" "}
        <a href="https://media.coinfallsmp.net" target="_blank" rel="noreferrer">
          media.coinfallsmp.net
        </a>
        .
      </p>
    </section>
  );
}
